import React from 'react';
import { getHowlerMusic } from 'js/components/audio/howler';

const AudioContext = React.createContext(null);

export const AudioProvider = ({ children }) => {
  const player = getHowlerMusic();
  const [audioEnabled, setAudioEnabled] = React.useState(true);

  React.useEffect(() => {
    if (!player) return () => {};

    audioEnabled ? player.play('background') : player.stop();
    return () => {};
  }, [audioEnabled, player]);

  const value = React.useMemo(
    () => ({
      audioEnabled,
      setAudioEnabled,
      toggleAudio: () => setAudioEnabled((enabled) => !enabled),
    }),
    [audioEnabled]
  );

  return <AudioContext.Provider value={value}>{children}</AudioContext.Provider>;
};

export const useAudio = () => {
  const context = React.useContext(AudioContext);

  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }

  return context;
};
